import React, { useMemo } from "react"
import CustomDatePicker, {
  CustomDatePickerProps,
} from "../Atoms/CustomDatePicker"
import { Icon, Intent } from "@blueprintjs/core"
import dayjs from "dayjs"

interface DateSelectorProps extends Omit<CustomDatePickerProps, "onChange"> {
  /**
   * Add an interface for future use
   */
  onChange: (path: any, value: any) => void
}
const DateSelector = ({
  value,
  onChange,
  path,
  ...otherProps
}: DateSelectorProps) => {
  const intent = useMemo(() => {
    const today = dayjs().format("YYYY-MM-DD")
    if (dayjs(today).isSame(value)) {
      return Intent.WARNING
    } else if (dayjs(value).isAfter(today)) {
      return Intent.SUCCESS
    } else {
      return Intent.DANGER
    }
  }, [value])
  return (
    <CustomDatePicker
      closeOnSelect={false}
      popoverProps={{
        popoverClassName: "vt_scheduling_date_popover",
      }}
      buttonProps={{
        id: "vt_scheduling_date_button",
      }}
      id="vt_scheduling_date_picker"
      className="mr-3"
      icon={<Icon icon="calendar" intent={intent}></Icon>}
      format="ddd MMM DD YYYY"
      value={value}
      onChange={onChange}
      path={path}
      {...otherProps}
    />
  )
}

export default DateSelector
